<template>
  <div class="food-manage">

    <div class="tuolele-main-box">
      <h2 class="wj-title">{{ analysisInfo.name }}</h2>
      <div class="wj-data"><span>发送人数: {{ analysisInfo.total_count }}</span><span style="margin-left: 10px;">参与人数: {{ analysisInfo.feedback_count }}</span>
        <el-button type="primary" @click="fnDownloadData()">下载详细数据</el-button>
      </div>
      <div class="wj-content">
        <div v-for="(item,index) in analysisInfo.contentJson" :key="index" class="wj-content-box">
          <h4>第{{ index+1 }}题：{{ item.question_title }}【{{ questionTypes[item.question_type] }}】</h4>
          <table v-if="item.question_type != '3'" border="1" cellspacing="0" cellpadding="0">
            <tr>
              <th>选项</th>
              <th>选择人数</th>
              <th>占比</th>
            </tr>
            <tr v-for="(sub,subindex) in item.option_extra" :key="'sub'+subindex">
              <td>{{ (sub.sign || "暂无选择") + '-' + sub.content }}</td>
              <td>{{ sub.choiceCount || "暂无选择" }}</td>
              <td>{{ sub.proportion ? (sub.proportion + "%") : "暂无选择" }}</td>
            </tr>
          </table>
          <p v-if="item.question_type == '3'" style="margin-top:10px;color:#333333">下载详细数据进行查看</p>
        </div>
      </div>
    </div>

  </div>

</template>
<script>

import commondata from '@/utils/commondata'
import Tool from '@/assets/js/tool.js'

export default {
  name: 'StockExerciseList',
  components: {

  },
  data() {
    return {
      postForm: {
        id: ''
      },
      analysisInfo: '',
      questionTypes: {}
    }
  },
  created() {
    this.postForm.id = this.$route.query.id || ''
    commondata.QUESTION_TYPE.forEach(ele => {
      this.questionTypes[ele.id] = ele.name
    })
    this.fnGetAnalysis()
  },
  methods: {
    fnGetAnalysis: function() {
      this.$http.getQuestionnaireStatistics(this.postForm).then(res => {
        this.analysisInfo = res.data
      })
    },
    fnDownloadData: function() {
      window.open(process.env.VUE_APP_BASE_URL + '/questionnaire/downloadQuestionnaire?template_id=' + this.analysisInfo.template_id)
    }

  }
}
</script>
<style lang="scss">
  .wj-title{
    color:#333333;
  }
  .wj-content-box {
    padding-top: 20px;
    h4 {
      color:#666666;
      font-weight:normal!important;
    }
    table {
      border-color:#666666;
      width: 700px;
      margin-top:20px;
      text-align: center;
      tr {
        color:#666666;
        td,th {
          font-weight:normal!important;
          padding: 4px 0px;
        }
      }
    }
  }
  .wj-data {
    color:#333333;
    margin-top:10px;
    .el-button{
      margin-left:20px
    }
    border-bottom:1px solid #ececec;
    padding-bottom:20px
  }
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
